module.exports = __webpack_public_path__ + "assets/bff8a12ac788b144bb8de62940fc6390.png";